import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PageTitle } from "../components/PageTitle";
import AccountSidebar from "../components/AccountSidebar";
import { useWishlistStore } from "../store/wishlistStore";
import { getImageUrl } from "../api/utils";
import ProductCard from "../components/ProductCard";
import MyAccountSidebarMobile from "../components/MyAccountSidebarMobile";

const FALLBACK_IMAGE = "/assets/images/product-placeholder.svg";

const formatPrice = (value) => {
  const n = Number(value);
  if (Number.isNaN(n)) return value;
  return n.toLocaleString("en-IN", {
    maximumFractionDigits: Number.isInteger(n) ? 0 : 2,
  });
};

const Wishlist = () => {
  const wishlist = useWishlistStore((s) => s.wishlist);
  const loading = useWishlistStore((s) => s.loading);
  const fetchWishlist = useWishlistStore((s) => s.fetchWishlist);
  const removeFromWishlist = useWishlistStore((s) => s.removeFromWishlist);
  const moveToCart = useWishlistStore((s) => s.moveToCart);

  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    fetchWishlist();
  }, [fetchWishlist]);

  return (
    <>
      <PageTitle
        title="My Account"
        subtitle="Your Hue. Your World. Your Space!"
        bgImage="default.png"
      />

      <section className="flat-spacing-11">
        <div className="container">
          <div className="row">
            {/* ── Sidebar ── */}
            <div className="col-lg-3">
              <AccountSidebar />
            </div>

            {/* ── Content ── */}
            <div className="col-lg-9">
              <div className="my-account-content account-wishlist">
                {/* Loading skeleton */}
                {loading && (
                  <div className="grid-layout wrapper-shop" data-grid="grid-3">
                    {[...Array(3)].map((_, i) => (
                      <div key={i} className="card-product">
                        <div className="card-product-wrapper">
                          <div
                            style={{
                              paddingTop: "120%",
                              background: "#f4f3ef",
                              animation: "pulse 1.4s ease-in-out infinite",
                            }}
                          />
                        </div>
                        <div
                          className="card-product-info"
                          style={{ padding: "12px 0" }}
                        >
                          <div
                            style={{
                              background: "#f4f3ef",
                              height: 14,
                              width: "70%",
                              marginBottom: 8,
                              animation: "pulse 1.4s ease-in-out infinite",
                            }}
                          />
                          <div
                            style={{
                              background: "#f4f3ef",
                              height: 14,
                              width: "40%",
                              animation: "pulse 1.4s ease-in-out infinite",
                            }}
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                )}

                {/* Empty state */}
                {!loading && wishlist.length === 0 && (
                  <div style={{ textAlign: "center", padding: "60px 0" }}>
                    <p style={{ fontSize: 40, marginBottom: 12 }}>🤍</p>
                    <p
                      style={{
                        fontSize: 16,
                        fontWeight: 600,
                        color: "#2c3a34",
                        marginBottom: 8,
                      }}
                    >
                      Your wishlist is empty!
                    </p>
                    <p
                      style={{ fontSize: 14, color: "#888", marginBottom: 20 }}
                    >
                      Add products you love and move them to cart anytime. 🌈
                    </p>
                    <Link
                      to="/products"
                      className="tf-btn btn-fill animate-hover-btn"
                    >
                      Browse Products
                    </Link>
                  </div>
                )}

                {/* Wishlist grid — same design as static */}
                {!loading && wishlist.length > 0 && (
                  <div className="row wrapper-shop">
                    {wishlist.map((item) => (
                      <ProductCard key={item.id} product={item} />
                    ))}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mobile sidebar toggle */}
      <div className="btn-sidebar-account">
        <button onClick={() => setSidebarOpen(true)}>
          <i className="icon icon-sidebar-2" />
        </button>
      </div>
      <MyAccountSidebarMobile
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
      />
    </>
  );
};

export default Wishlist;
